/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ProblemDetails,
  SendSmsRequest,
  SendSmsResponse,
  ValidationProblemDetails,
} from '../models/index';
import {
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    SendSmsRequestFromJSON,
    SendSmsRequestToJSON,
    SendSmsResponseFromJSON,
    SendSmsResponseToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface SendSmsOperationRequest {
    clientId: string;
    sendSmsRequest: SendSmsRequest;
}

/**
 * SmsApi - interface
 * 
 * @export
 * @interface SmsApiInterface
 */
export interface SmsApiInterface {
    /**
     * 
     * @param {string} clientId 
     * @param {SendSmsRequest} sendSmsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmsApiInterface
     */
    sendSmsRaw(requestParameters: SendSmsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendSmsResponse>>;

    /**
     */
    sendSms(requestParameters: SendSmsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendSmsResponse>;

}

/**
 * 
 */
export class SmsApi extends runtime.BaseAPI implements SmsApiInterface {

    /**
     */
    async sendSmsRaw(requestParameters: SendSmsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendSmsResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling sendSms().'
            );
        }

        if (requestParameters['sendSmsRequest'] == null) {
            throw new runtime.RequiredError(
                'sendSmsRequest',
                'Required parameter "sendSmsRequest" was null or undefined when calling sendSms().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/sms`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendSmsRequestToJSON(requestParameters['sendSmsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SendSmsResponseFromJSON(jsonValue));
    }

    /**
     */
    async sendSms(requestParameters: SendSmsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendSmsResponse> {
        const response = await this.sendSmsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
